export const BASE_SCENE_ID = 'a9c818ef-29c7-4603-a71e-841cb74cbc1b'; //empty scene

export const IN_TO_M = 0.0254;
export const PRODUCT_ID = '5c1cf0faf2ff4600011aab82';
export const ORDER_API_URL =
  'https://mythreekit.com/api/organizations/bostontec/orders';
export const APP_URL = 'https://bostontec.mythreekit.com';
export const BACKSTOP_OFFSET = 3;
export const SNAPSHOT_CAMERAS = {
  angleView: 'Camera_AngleView',
  sideView: 'Camera_SideView',
};
export const CAMERA_TARGET = 'Camera_Snapshot_Target';
export const LOGIN_EVENT = 'dealerLogin';
export const LOGOUT_EVENT = 'dealerLogout';
export const MOVEMENT_SEARCH_RANGE = 5;
export const INDUSTRY_TYPE = [
  { key: 'Aerospace', value: 'Aerospace', text: 'Aerospace' },
  { key: 'Electronics', value: 'Electronics', text: 'Electronics' },
  {
    key: 'Government/Military',
    value: 'Government/Military',
    text: 'Government/Military',
  },
  {
    key: 'Laboratory including Medical/School',
    value: 'Laboratory including Medical/School',
    text: 'Laboratory including Medical/School',
  },
  { key: 'Manufacturer', value: 'Manufacturer', text: 'Manufacturer' },
  {
    key: 'Material Handling',
    value: 'Material Handling',
    text: 'Material Handling',
  },
  { key: 'Medical', value: 'Medical', text: 'Medical' },

  { key: 'Pharmacy', value: 'Pharmacy', text: 'Pharmacy' },
  { key: 'Retail', value: 'Retail', text: 'Retail' },
  { key: 'School/Office', value: 'School/Office', text: 'School/Office' },
  { key: 'Other', value: 'Other', text: 'Other' },
];

// this is used for additional overlay check between multiply blocks.
// the axis is the axis item can not overlap
// the incompatibilityItems is the items that can not be overlay in the given axis
export const SPECIAL_OVERLAY_CHECK = [
  {
    axis: 'x',
    incompatibleItems: [
      { items: ['FSFR'], block: ['base', 'footrest'] },
      {
        items: [
          'CPU12',
          'CPU20',
          'DRW12',
          'DRWF12',
          'DRW2412',
          'DRW26',
          'DRW2426',
          'DRW212',
          'DRW24212',
          'DRW36',
          'DRW2436',
          'DRW612',
          'DRWF612',
          'DRW24612',
          'DRW3612',
          'DRW243612',
        ],
        block: ['base', 'underSurface'],
      },
      {
        items: [
          'UWSBPDDF1436',
          'UWSDDF1436',
          'UWSBPDDF1448',
          'UWSDDF1448',
          'UWSBPDDF1460',
          'UWSDDF1460',
          'UWSBPDDF1472',
          'UWSDDF1472',
        ],
        block: ['base', 'underSurface'],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/constants.js